export default "__VITE_ASSET__Chcng6ij__"